export default "__VITE_ASSET__BwBpXZH3__"